import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AppStoreManager from './components/AppStoreManager';
import DeveloperSection from './components/DeveloperSection';
import Sidebar from './components/Sidebar';
import { checkAuthStatus } from './services/api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [appData, setAppData] = useState({
    appName: null,
    currentVersion: null,
    sections: []
  });
  const [activeSection, setActiveSection] = useState('testflight');

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await checkAuthStatus();
      setIsAuthenticated(response.data.authenticated);
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setAppData({ appName: null, currentVersion: null, sections: [] });
  };

  const updateAppData = useCallback((data) => {
    setAppData(data);
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <Router>
      {isAuthenticated ? (
        <div className="app-layout">
          <Sidebar
            appName={appData.appName}
            currentVersion={appData.currentVersion}
            sections={appData.sections}
            activeSection={activeSection}
            onSectionChange={setActiveSection}
          />
          <div className="content-area">
            <div className="content-main">
              <Routes>
                <Route
                  path="/"
                  element={<Dashboard />}
                />
                <Route
                  path="/appstore"
                  element={
                    <AppStoreManager
                      onAppDataUpdate={updateAppData}
                      activeSection={activeSection}
                      onSectionChange={setActiveSection}
                    />
                  }
                />
                <Route
                  path="/developer"
                  element={<DeveloperSection />}
                />
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <Routes>
          <Route
            path="/login"
            element={<Login onLogin={handleLogin} />}
          />
          <Route
            path="*"
            element={<Navigate to="/login" replace />}
          />
        </Routes>
      )}
    </Router>
  );
}

export default App;
